var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"qr-modal__qr-code"},[_c('img',{attrs:{"src":("data:image/svg+xml;base64," + _vm.generatedQrCode)}})])}
var staticRenderFns = []

export { render, staticRenderFns }